import { z } from "zod/v4";

export const SessionJWTPayloadSchema = z.object({
  sessionId: z.string(),
});

export type SessionJWTPayload = z.infer<typeof SessionJWTPayloadSchema>;

export const passwordMinLength = 8;

export const passwordSchema = z
  .string()
  .min(passwordMinLength)
  .max(255)
  .refine((password) => /[A-Z]/.test(password), {
    params: {
      i18n: {
        key: "uppercase_character_required",
        values: {
          character: "A-Z",
        },
      },
    },
  })
  .refine((password) => /[0-9]/.test(password), {
    params: {
      i18n: {
        key: "number_required",
        values: {
          character: "0-9",
        },
      },
    },
  })
  .refine((password) => /[!@#$%^&*]/.test(password), {
    params: {
      i18n: {
        key: "special_character_required",
        values: {
          character: "!@#$%^&",
        },
      },
    },
  });
